module.exports = __webpack_public_path__ + "static/sc-09-eb5f6828d743a1c3b7a4caa278d9fa75.png";